// กองการ์ดตั้งต้นของผู้เล่นเมื่อกด "เริ่มเกมใหม่" (Day 1)
export const INITIAL_MASTER_DECK = [
  'raw_pork', 
  'raw_pork', 
  'raw_chicken', 
  'raw_papaya',
  'raw_chili',
  'raw_garlic'
];

export const GAME_SETTINGS = {
  initialAP: 10,       // พลังงานเริ่มต้นในแต่ละวัน
  initialTarget: 100,  // เป้าหมายยอดขายวันแรก
  maxBuffSlots: 5,     // ช่องใส่อุปกรณ์ก้นครัวสูงสุด
  initialMoney: 150    // 💰 ทุนเริ่มต้นสำหรับจัดเด็คก่อนเริ่มเล่น Day 1
};